import React from 'react'
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Box
} from '@chakra-ui/react'
import { IStackedColumnChartData } from '../ColumnStacked'

interface IDataTableProps {
  data: IStackedColumnChartData
}

export const TabelaCiclica: React.FC<IDataTableProps> = ({ data }) => {
  if (!data?.dates?.length || !data.series || !data.series.length) {
    return (
      <Text p={5} textAlign="center" fontStyle="italic">
        Dados não disponíveis para exibir na tabela. 📊
      </Text>
    )
  }

  return (
    <Box
      mt={5}
      boxShadow="md"
      borderRadius=".25rem"
      overflow="hidden"
      w={'full'}
      fontSize={'14px'}
    >
      <TableContainer w={'full'}>
        <Table variant="striped" colorScheme="gray" w={'full'}>
          <Thead>
            <Tr>
              <Th
                bg="var(--Azul)"
                color="white"
                px={4}
                py={3}
                textAlign="left"
                textTransform="uppercase"
                letterSpacing="wider"
                fontSize="sm"
              >
                Questão
              </Th>
              {data.dates.map((date, index) => (
                <Th
                  key={index}
                  bg="var(--Azul)"
                  color="white"
                  px={4}
                  py={3}
                  textAlign="center"
                  textTransform="uppercase"
                  letterSpacing="wider"
                  fontSize="sm"
                >
                  {date}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {data.series.map((serie) => (
              <Tr key={serie.name}>
                <Td px={4} py={3} fontWeight="medium" textAlign="left">
                  {serie.name}
                </Td>
                {serie.data.map((value, valueIndex) => (
                  <Td key={valueIndex} px={4} py={3} textAlign="center">
                    {value}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}
